import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import InnerBox from '@repo/ui/inner-box'
import { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

import { CseInput } from '../../../lib/types/models/cse/cse'
import ControlledSwitch from '../../elements/controlled-switch'
import { FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledInput from '../../elements/inputs/controlled-input'

const CseExtraOptionFormSection = () => {
  const form = useFormContext<CseInput>()
  const extraOptionEnabled = form.watch('extraOptionEnabled')

  useEffect(() => {
    if (!extraOptionEnabled) form.setValue('extraOptionLabel', null)
  }, [extraOptionEnabled, form])

  return (
    <InnerBox title="Options du champ personnalisé" className="rounded-xl">
      <FormField
        control={form.control}
        name={'extraOptionEnabled'}
        render={({ field }) => (
          <FormItem>
            <FormControl>
              <ControlledSwitch
                {...field}
                switchVariant="primary"
                label="Ajouter un champ personnalisé dans le formulaire"
                variant={'label-medium'}
                color={tailwindColors.black.DEFAULT}
              />
            </FormControl>
          </FormItem>
        )}
      />
      <div className="h-3" />
      {extraOptionEnabled && (
        <FormField
          control={form.control}
          name="extraOptionLabel"
          render={({ field }) => (
            <FormItem className="flex-1">
              <FormControl>
                <ControlledInput {...field} label="Nom du champ" type="text" />
              </FormControl>
            </FormItem>
          )}
        />
      )}
    </InnerBox>
  )
}

export default CseExtraOptionFormSection
